import { useState, useEffect } from 'react';
import { getAllOtherDocs, ICandidate, IDocument } from 'wisestep-api';

const useGetSubmissionOtherDocs = (submission: ICandidate) => {
  const [otherDocuments, setOtherDocuments] = useState<IDocument[]>([]);

  useEffect(() => {
    (async () => {
      if (!submission?.id) return;
      try {
        const { data } = await getAllOtherDocs(submission.id);
        if (data) {
          setOtherDocuments(data);
        }
      } catch {
        console.error('Error while fetching submission other documents');
      }
    })();
  }, [submission?.id]);

  return { otherDocuments, setOtherDocuments };
};

export default useGetSubmissionOtherDocs;
